import { useEffect } from 'react'
import { useSignal, batch } from '@preact/signals-react'
import { postSubmit } from '@ui-seeker/utils'

import {isLoadingCommonFilters, commonFiltersValue, isSystemBusy, userData} from '@signals'
import { WEBBACK_V2_API } from '@constants'


export default function useMonitoringAdminTableFilters() {

    const data = useSignal([])
    const isLoading = useSignal(false)

    useEffect(() => {
        if (isLoadingCommonFilters.value) batch(() => {
            isLoading.value = true
            postSubmit(`${WEBBACK_V2_API}/monitoring/admin/context`, commonFiltersValue.value)
                .then(res => {
                    data.value = res
                    isLoading.value = false
                    isLoadingCommonFilters.value = false
                })
                .catch(() => {
                    isSystemBusy.value = true
                    isLoadingCommonFilters.value = false
                })
        })
    }, [isLoadingCommonFilters.value])

    return {
        data: data.value,
        isLoading: isLoading.value,
        isAdmin: userData.value?.modules?.includes('monitoringAdmin')
    }
}